 
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ConfigurationCore } from '@app-libs/core';

@Injectable({
  providedIn: 'root',
})
export class ConfigurationClientService extends ConfigurationCore {
  constructor() {
    super();
    this.settings.general.isClient = true;
  }

  // Access environment variables
  get env(): any {
    return environment;
  }

  getBackendAPIUrl(): string {
    return environment.BACKEND_API_URL;
  }
}
